// tanstack
import { useNavigate } from '@tanstack/react-router';

// material ui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

const LogoComponent = () => {
  const navigate = useNavigate();

  const handleNavigateToHome = () => {
    navigate({ to: '/' });
  };
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ml: -0.5,
      }}
    >
      {/* <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: '40px',
            height: '40px',
            backgroundColor: '#212121',
            border: '1px solid hsl(0, 0.00%, 20%)',
            borderRadius: '40%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <svg width="25" height="25" viewBox="0 0 40 40">
            <defs>
              <linearGradient
                id="logo_gradient"
                x1="100%"
                y1="100%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="hsl(63, 100%, 20%)" />
                <stop offset="100%" stopColor="hsl(63, 100%, 70%)" />
              </linearGradient>
            </defs>
            <circle
              cx="20"
              cy="20"
              r="16"
              stroke="url(#logo_gradient)"
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </div>
      </Box> */}
      <Link
        underline="none"
        onClick={handleNavigateToHome}
        sx={{
          ml: 2,
          fontFamily: 'neuropolitical',
          ':hover': {
            cursor: 'pointer',
            '.M': { color: 'hsl(63, 100%, 45%)' },
          },
        }}
      >
        <Box fontSize="24px" sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="label"
            className="Re"
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? 'hsl(0, 0%, 20%)'
                  : 'hsl(0, 0%, 85%)',
              fontWeight: 'medium',
            }}
          >
            Re
          </Typography>
          <Typography
            variant="label"
            className="M"
            sx={{
              color: 'hsl(63, 100%, 40%)',
              fontWeight: 'medium',
              transition: '0.3s',
            }}
          >
            M
          </Typography>
          <Typography
            variant="label"
            className="oni"
            fontSize="inherit"
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? 'hsl(0, 0%, 20%)'
                  : 'hsl(0, 0%, 85%)',
              fontWeight: 'medium',
            }}
          >
            oni
          </Typography>
        </Box>
      </Link>
    </Box>
  );
};

export default LogoComponent;
